<template>
  <el-dialog center :modal="true" width="600px" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="outerVisible" @close="closeVisible">
    <div class="title" slot="title" v-if="!isCancel">
      <i class="el-icon-warning"></i>您确定要取消订单吗 ？取消订单后，不能恢复
    </div>
    <div class="chancle-select" v-if="!isCancel">
      <div class="select-lf">请选择取消订单的理由</div>
      <div class="select-lr">
        <el-select v-model="submitObj.cancelReason" style="width:206px;" size="mini" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.label"></el-option>
        </el-select>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" v-if="!isCancel">
      <el-button @click="outerVisible = false" size="mini">取 消</el-button>
      <el-button type="primary" @click="cancelOrder" size="mini" :loading="loading">确认</el-button>
    </div>
    <div class="cancel_apply" v-if="isCancel">
      <div class="cancel_title">
        <i class="el-icon-circle-check"></i>
      </div>
      <div class="apply">
        <span>取消申请已提交，系统正在审核</span>
      </div>
      <div class="datail">
        <span>请耐心等待，您可在“</span>
        <router-link :to="{path:'/personalCenter/cancelDetail',query:{id: applyId}}" target="_blank">取消详情</router-link>
        <span>”中查看退款进度</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    GetCancelOrder: {
      type: Function,
      default: () => {},
    },
    CancelOrder: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      outerVisible: false,
      isCancel: false,
      loading: false,
      options: [],
      submitObj: {
        orderBatchId: "",
        cancelReason: "",
      },
      applyId: "",
    };
  },
  methods: {
    showModal(id) {
      this.resultForm();
      this.outerVisible = true;
      this.submitObj.orderBatchId = id;
      this.GetCancelOrder().then((res) => {
        if (res.isSuccess == 1) {
          var data = res.data;
          data.forEach((v, i) => {
            this.options.push({
              value: v.id,
              label: v.name,
            });
          });
        }
      });
    },
    cancelOrder() {
      if (this.submitObj.cancelReason == "") {
        this.$message.warning("请选择取消原因");
        return false;
      }
      this.loading = true;
      this.CancelOrder(this.submitObj)
        .then((res) => {
          // console.log('取消订单',res);
          this.loading = false;
          this.isCancel = true;
          this.applyId = res.data[0].id;
        })
        .catch((err) => {
          this.isCancel = false;
          this.loading = false;
        });
    },
    closeVisible() {
      this.$emit("refresh");
    },
    resultForm() {
      this.submitObj = {
        orderBatchId: "",
        cancelReason: "",
      };
      this.options = [];
      this.isCancel = false;
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-dialog--center {
  border: 4px solid #909090;
  height: 300px;
}
.title {
  width: 355px;
  height: 29px;
  border: 1px solid @themeColor;
  line-height: 29px;
  font-size: 12px;
  color: #1a1a1a;
  margin: 0 auto;
  i {
    color: @themeColor;
    font-size: 24px;
    vertical-align: middle;
    margin-right: 15px;
  }
}
.chancle-select {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  .select-lf {
    margin-right: 12px;
    height: 30px;
    color: #1a1a1a;
    line-height: 30px;
  }
}
.dialog-footer {
  margin-top: 80px;
  width: 80%;
  display: flex;
  justify-content: flex-end;
  // width: 160px;
}
.el-dialog__body {
  .cancel_apply {
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    .cancel_title {
      color: rgb(123 188 82);
      font-size: 48px;
    }
    .apply {
      font-size: 16px;
      font-weight: bold;
      color: #515151;
    }
  }
}
</style>